import React from 'react';
import { useTranslation } from 'react-i18next';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';

export interface PlanEnabledChipProps {
  enabled: boolean;
  // Only the tenant-facing dashboard explains the gap ("not included in your
  // current plan") — a system admin looking at someone else's account is not
  // the addressee of that sentence.
  disabledTooltip?: string;
}

/** Enabled / disabled badge for a plan feature. */
export default function PlanEnabledChip({
  enabled,
  disabledTooltip,
}: PlanEnabledChipProps) {
  const { t } = useTranslation();
  return (
    <Chip
      type={enabled ? ChipTypes.chipGreen : ChipTypes.chipGray}
      label={enabled ? t('enabled') : t('disabled')}
      tooltip={enabled ? undefined : disabledTooltip}
    />
  );
}
